// Vendor libraries
import { EventEmitter, TemplateRef } from '@angular/core';
import cloneDeep from 'lodash.clonedeep';
import { MAX_VIEW_DEPTH } from 'FoldersApp/constants/folderable-app-config.constants';
// Services
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import { FolderExpansionService } from 'FoldersApp/services/folder-expansion-service/folder-expansion.service';
import { SharingService } from 'SharingApp/ts/services/sharing.service';
import * as i0 from "@angular/core";
import * as i1 from "FoldersApp/services/folderable-collection-service-base.service";
import * as i2 from "FoldersApp/services/folder-expansion-service/folder-expansion.service";
import * as i3 from "SharingApp/ts/services/sharing.service";
import * as i4 from "@angular/common";
import * as i5 from "../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i6 from "../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i7 from "../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i8 from "FoldersApp/features/folders-shared/folderable/folderable.directive";
import * as i9 from "FoldersApp/features/folders-shared/set-view-root-folder/set-view-root-folder.directive";
import * as i10 from "../../../../../sharing/static/sharing/ts/pipes/is-shared-with-others.pipe";
const _c0 = a0 => ({ folder: a0 });
const _c1 = a0 => ({ "show": a0 });
const _c2 = (a0, a1, a2) => ({ id: a0, name: a1, permissions: a2 });
const _c3 = (a0, a1) => ({ folderable: a0, ancestorInfo: a1 });
function _forTrack0($index, $item) { return this.trackFolderable($item); }
function FolderBaseComponent_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("click", function FolderBaseComponent_Conditional_3_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.folderToggleHandler()); });
    i0.ɵɵelement(1, "div", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c1, ctx_r1.folderExpansionService.isExpanded(ctx_r1.folder.id)));
} }
function FolderBaseComponent_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 6);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.folderNameFragment)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c0, ctx_r1.folder));
} }
function FolderBaseComponent_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "a", 7);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r1.folder.name)("disabled", !(ctx_r1.folder.permissions == null ? null : ctx_r1.folder.permissions.canView))("folderId", ctx_r1.folder.id);
} }
function FolderBaseComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tooltipHtml", true)("tooltipPlacement", "bottom")("tooltipTitle", ctx_r1.sharingTooltipMessage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-team");
} }
function FolderBaseComponent_Conditional_11_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 12);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.emptyFolderFragment);
} }
function FolderBaseComponent_Conditional_11_Conditional_1_For_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementContainer(1, 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const folderable_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r1.folderExpansionService.getCssClasses(folderable_r3))("id", ctx_r1.folderExpansionService.getId(folderable_r3));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.listItemFragment)("ngTemplateOutletContext", i0.ɵɵpureFunction2(8, _c3, folderable_r3, i0.ɵɵpureFunction3(4, _c2, ctx_r1.folder.id, ctx_r1.folder.name, ctx_r1.folder.permissions)));
} }
function FolderBaseComponent_Conditional_11_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, FolderBaseComponent_Conditional_11_Conditional_1_For_1_Template, 2, 11, "div", 13, _forTrack0, true);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵrepeater(ctx_r1.folder.items);
} }
function FolderBaseComponent_Conditional_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FolderBaseComponent_Conditional_11_Conditional_0_Template, 1, 1, "ng-container", 12)(1, FolderBaseComponent_Conditional_11_Conditional_1_Template, 2, 0);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.folder.items && ctx_r1.folder.items.length === 0 ? 0 : 1);
} }
export class FolderBaseComponent {
    get folder() {
        if (this.folderable.resourceType !== 'folder') {
            throw new Error('TypeError: `folderItem` should be a folder.');
        }
        return this.folderable.item;
    }
    get isExpandable() {
        if (this.folderable.viewDepth > this.maxViewDepth - 1)
            return false;
        return !this.folderableCollectionService.textSearchActive;
    }
    constructor(folderableCollectionService, folderExpansionService, sharingService) {
        this.folderableCollectionService = folderableCollectionService;
        this.folderExpansionService = folderExpansionService;
        this.sharingService = sharingService;
        this.maxViewDepth = MAX_VIEW_DEPTH;
        this.folderableClick = new EventEmitter();
        this.sharingTooltipMessage = '';
    }
    ngOnInit() {
        this.sharingTooltipMessage = this.sharingService.getSharingTooltipMessage(this.folderable.item);
    }
    folderToggleHandler() {
        if (this.folder === null)
            return;
        this.folderExpansionService.toggle(this.folder.id, this.ancestorInfo.id);
        // There seems to be a change detection bug.
        // changeDetectionRef.detectChanges() does not detect changes for sub-folder components.
        // Replace `folderItem` with a new reference to force change detection.
        this.folderable = cloneDeep(this.folderable);
    }
    folderableClickHandler(event) {
        // Ignore the click when a button child of the folder item wrapper element was clicked.
        if (event.target.closest('.btn') !== null)
            return;
        this.folderableClick.emit(this.folderable);
    }
    trackFolderable(folderable) {
        const { resourceType, item } = folderable;
        let unique_id;
        if ('id' in item) {
            unique_id = item.id;
        }
        else if ('name' in item) {
            unique_id = item.name;
        }
        else {
            unique_id = btoa(JSON.stringify(item));
        }
        return `${resourceType}-${unique_id}`;
    }
}
FolderBaseComponent.ɵfac = function FolderBaseComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderBaseComponent)(i0.ɵɵdirectiveInject(i1.FolderableCollectionServiceBase), i0.ɵɵdirectiveInject(i2.FolderExpansionService), i0.ɵɵdirectiveInject(i3.SharingService)); };
FolderBaseComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FolderBaseComponent, selectors: [["ycn-folder-base"]], inputs: { folderable: "folderable", ancestorInfo: "ancestorInfo", folderColumnDataFragment: "folderColumnDataFragment", listItemFragment: "listItemFragment", emptyFolderFragment: "emptyFolderFragment", folderNameFragment: "folderNameFragment", maxViewDepth: "maxViewDepth" }, outputs: { folderableClick: "folderableClick" }, standalone: false, decls: 12, vars: 13, consts: [["ycn-folderable", "", 1, "tr", 3, "click", "folderable", "ancestorInfo"], [1, "td", "file-td-name"], [1, "file-name", "file-td-wrap"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent2", "category-toggler", 3, "ngClass"], [1, "file-icon"], ["ycnIcon", "", 3, "name"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["draggable", "false", "href", "javascript:void(0)", "ycnDisabled", "", "ycn-set-view-root-folder", "", 3, "textContent", "disabled", "folderId"], ["class", "btn btn-xs btn-circle btn-transparent btn-share ml-1", "ycnTooltip", "", 3, "tooltipHtml", "tooltipPlacement", "tooltipTitle", 4, "ngIf"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent2", "category-toggler", 3, "click", "ngClass"], [1, "collapse-chevron"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-share", "ml-1", 3, "tooltipHtml", "tooltipPlacement", "tooltipTitle"], [3, "ngTemplateOutlet"], [3, "ngClass", "id"]], template: function FolderBaseComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("click", function FolderBaseComponent_Template_div_click_0_listener($event) { return ctx.folderableClickHandler($event); });
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, FolderBaseComponent_Conditional_3_Template, 2, 3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(5, "svg", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, FolderBaseComponent_Conditional_6_Template, 1, 4, "ng-container", 6)(7, FolderBaseComponent_Conditional_7_Template, 1, 3, "a", 7)(8, FolderBaseComponent_div_8_Template, 2, 4, "div", 8);
        i0.ɵɵpipe(9, "isSharedWithOthers");
        i0.ɵɵelementEnd()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementContainer(10, 6);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(11, FolderBaseComponent_Conditional_11_Template, 2, 1);
    } if (rf & 2) {
        i0.ɵɵproperty("folderable", ctx.folderable)("ancestorInfo", ctx.ancestorInfo);
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.isExpandable ? 3 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("name", "icon-folder");
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.folderNameFragment ? 6 : 7);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(9, 9, ctx.folder));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.folderColumnDataFragment)("ngTemplateOutletContext", i0.ɵɵpureFunction1(11, _c0, ctx.folder));
        i0.ɵɵadvance();
        i0.ɵɵconditional(!ctx.folderableCollectionService.textSearchActive && ctx.folderExpansionService.isExpanded(ctx.folder.id) ? 11 : -1);
    } }, dependencies: [i4.NgClass, i4.NgIf, i4.NgTemplateOutlet, i5.IconDirective, i6.TooltipDirective, i7.DisabledDirective, i8.FolderableDirective, i9.SetViewRootFolderDirective, i10.IsSharedWithOthersPipe], encapsulation: 2 });
